<div class="content-wrapper-inner">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="filter-form">
    <audit-filter-form-component-v2 (onSubmit)="onFilter($event)"></audit-filter-form-component-v2>
  </div>
  <div class="hr-line-dashed"></div>
  <div>
    <table class="w-100">
      <thead>
        <tr>
          <th class="w-sm">Time</th>
          <th class="user-column">User</th>
          <th class="w-md">Resource</th>
          <th class="w-lg">Device</th>
          <th class="w-sm">Service</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <td class="w-sm">{{row.createdAt | date:'MMMM d, y' }} <br>{{ row.createdAt | date:'h:mm:ss a' }}</td>
          <td class="user-column">{{row.userEmail}}</td>
          <td class="w-md">
            <div (click)="showDetails(row)" [ngClass]="(isAdmin && row.requestDetails) ? 'has-details' : 'no-details'">
              <span *ngIf="row.method" [ngClass]="'method-' + row.method">{{ row.method }}</span> {{row.resource}} <i *ngIf="isAdmin && row.requestDetails"
                class="fas fa-list-ul details-icon"></i>
            </div>
          </td>
          <td class="w-lg"><ng-container *ngIf="row.ip">{{row.ip}} / </ng-container> {{row.userAgent}}</td>
          <td class="w-sm">{{row.service}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-center mt-20">
    <button type="button" (click)="next()" class="btn btn-primary">More</button>
  </div>
</div>

<ng-template #detailsModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Log details <small>{{ currentLog.log.resource }}</small></h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="log-info">
      <dl class="description-list">
        <dt>Date</dt>
        <dd>{{ currentLog.log.createdAt | date:'MMMM d, y' }}</dd>
        <dt>User</dt>
        <dd>{{ currentLog.log.userEmail }}</dd>
        <dt>Url</dt>
        <dd>{{ currentLog.log.method }} {{ currentLog.log.resource }}</dd>
        <dt>Service</dt>
        <dd>{{ currentLog.log.service }}</dd>
        <dt>IP</dt>
        <dd>{{ currentLog.log.ip }}</dd>
        <dt>Device</dt>
        <dd>{{ currentLog.log.userAgent }}</dd>
      </dl>
    </div>
    <div class="log-details">
      <div class="raw" *ngIf="!currentLog.details.parsed.size">
        <pre style="padding-bottom: 15px">{{ currentLog.details.raw }}</pre>
      </div>
      <dl class="description-list">
        <ng-container *ngFor="let item of currentLog.details.parsed| keyvalue">
          <dt>{{ item.key }}</dt>
          <dd>{{ item.value }}</dd>
        </ng-container>
      </dl>
    </div>
  </div>
</ng-template>
